export default {
	"productOverview.toFamilyPage": "Alle {familyName}-Produke ansehen",
	"productOverview.localProduct": "Antrag online möglich",
	"productOverview.externalProduct": "Kontaktaufnahme",
} as const;
